import { Order } from '../order/types'
import { Security } from '../securities/reducer'
import {
  AggressorWindowInfo,
  LastLookWindowInfo,
  RfqWindowInfo,
  SecurityModalInfo
} from './types'

export const openAggressorWindow = (
  initialOrderId: Order['id'],
  securityId: Security['id'],
  listId?: number
) =>
  ({
    type: 'windows.openAggressorWindow',
    payload: { initialOrderId, securityId, listId } as const
  } as const)
export type OpenAggressorWindowAction = ReturnType<typeof openAggressorWindow>

export const fetchDataForSecurityModal = (orderId: Order['id'], size: number) =>
  ({
    type: 'windows.fetchDataForSecurityModal',
    payload: { orderId, size }
  } as const)
export type FetchDataForSecurityModalAction = ReturnType<
  typeof fetchDataForSecurityModal
>

export const unsubscribeFetchDataForSecurityModal = (orderId: Order['id']) =>
  ({
    type: 'windows.unsubscribeFetchDataForSecurityModal',
    payload: { orderId }
  } as const)
export type UnsubscribeFetchDataForSecurityModalAction = ReturnType<
  typeof unsubscribeFetchDataForSecurityModal
>

export const updateDataForSecurityModal = (
  initialOrderId: Order['id'],
  securityModalInfo: SecurityModalInfo
) =>
  ({
    type: 'windows.updateDataForSecurityModal',
    payload: { initialOrderId, securityModalInfo }
  } as const)
export type UpdateDataForSecurityModalAction = ReturnType<
  typeof updateDataForSecurityModal
>

export const addAggressorWindow = (windowInfo: AggressorWindowInfo) =>
  ({ type: 'windows.addAggressorWindow', payload: windowInfo } as const)
export type AddAggressorWindowAction = ReturnType<typeof addAggressorWindow>

export const addLastLookWindow = (windowInfo: LastLookWindowInfo) =>
  ({ type: 'windows.addLastLookWindow', payload: windowInfo } as const)
export type AddLastLookWindowAction = ReturnType<typeof addLastLookWindow>

export const addRfqWindow = (windowInfo: RfqWindowInfo) =>
  ({ type: 'windows.addRfqWindow', payload: windowInfo } as const)
export type AddRfqWindowAction = ReturnType<typeof addRfqWindow>

export const removeAggressorWindow = (windowInfo: AggressorWindowInfo) =>
  ({ type: 'windows.removeAggressorWindow', payload: windowInfo } as const)
export type RemoveAggressorWindowAction = ReturnType<
  typeof removeAggressorWindow
>

export const aggressorWindowClosed = (initialOrderId: Order['id']) =>
  ({
    type: 'windows.aggressorWindowClosed',
    payload: { initialOrderId }
  } as const)
export type AggressorWindowClosedAction = ReturnType<
  typeof aggressorWindowClosed
>

export const lastLookWindowClosed = (orderId: Order['id']) =>
  ({ type: 'windows.lastLookWindowClosed', payload: { orderId } } as const)
export type LastLookWindowClosedAction = ReturnType<typeof lastLookWindowClosed>

export const removeLastLookFromWindows = (window: LastLookWindowInfo) =>
  ({ type: 'windows.removeLastLookFromWindows', payload: { window } } as const)
export type RemoveLastLookFromWindows = ReturnType<
  typeof removeLastLookFromWindows
>

export const removeRfqWindow = (window: RfqWindowInfo) =>
  ({ type: 'windows.removeRfqWindow', payload: window } as const)
export type RemoveRfqWindowAction = ReturnType<typeof removeRfqWindow>

export const foregroundAggressorWindowAtIndex = (index: number | undefined) =>
  ({
    type: 'windows.foregroundAggressorWindowAtIndex',
    payload: index
  } as const)
export type ForegroundAggressorWindowAtIndexAction = ReturnType<
  typeof foregroundAggressorWindowAtIndex
>

export const foregroundAggressorWindow = (orderId: Order['id']) =>
  ({ type: 'windows.foregroundAggressorWindow', payload: orderId } as const)
export type ForegroundAggressorWindowAction = ReturnType<
  typeof foregroundAggressorWindow
>

export const setRfqActiveWindowIndex = (index: number | undefined) =>
  ({ type: 'windows.setRfqActiveWindowIndex', payload: index } as const)
export type SetRfqActiveWindowIndexAction = ReturnType<
  typeof setRfqActiveWindowIndex
>

export const hideRfqWindow = (orderId: string) =>
  ({ type: 'windows.hideRfqWindow', payload: { orderId } } as const)
export type HideRfqWindowAction = ReturnType<typeof hideRfqWindow>

export const showRfqWindow = (orderId: string) =>
  ({ type: 'windows.showRfqWindow', payload: { orderId } } as const)
export type ShowRfqWindowAction = ReturnType<typeof showRfqWindow>

export const setWindowFront = (windowFront: string) =>
  ({ type: 'windows.setWindowFront', payload: windowFront } as const)
export type SetWindowFront = ReturnType<typeof setWindowFront>

export type WindowsAction =
  | AggressorWindowClosedAction
  | LastLookWindowClosedAction
  | RemoveLastLookFromWindows
  | RemoveAggressorWindowAction
  | RemoveRfqWindowAction
  | HideRfqWindowAction
  | ForegroundAggressorWindowAction
  | ForegroundAggressorWindowAtIndexAction
  | FetchDataForSecurityModalAction
  | OpenAggressorWindowAction
  | UnsubscribeFetchDataForSecurityModalAction
  | UpdateDataForSecurityModalAction
  | AddAggressorWindowAction
  | AddLastLookWindowAction
  | AddRfqWindowAction
  | ShowRfqWindowAction
  | SetWindowFront
  | SetRfqActiveWindowIndexAction
